import { Box, Typography } from '@mui/material';
import React from 'react';

const HtmlComponent = ({ htmlString }) => {
  return (
    <Box
      sx={{
        pl: 0,
        mx: 0,
        mb: 0,
        mt: 0,
        width: '100%',
        textAlign: 'left',
      }}
      className="ml-form-field-note-root"
    >
      <Typography
        component="div"
        sx={{
          color: 'rgba(0, 0, 0, 0.6)',
          fontSize: '18px',
          letterSpacing: '0.7px',
          '& *': {
            color: 'inherit !important',
          },
        }}
        dangerouslySetInnerHTML={{ __html: htmlString }}
      />
    </Box>
  );
};

export default HtmlComponent;
